import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import classes from "./Breadcrumb.module.css";

const Breadcrumb = (props) => {
  const { className, paths } = props;

  return (
    <nav
      className={classNames(classes["breadcrumb"], className)}
      aria-label="breadcrumb"
    >
      <ol className={classes["breadcrumb__list"]}>
        {paths.map((path, index) => (
          <li
            key={index}
            aria-current={path.url ? "page" : undefined}
            className={classNames(classes["breadcrumb__path"], {
              [classes["breadcrumb__path--clickable"]]: path.url,
            })}
          >
            {path.url ? (
              <Link to={path.url}>{path.label}</Link>
            ) : (
              <span>{path.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;

Breadcrumb.propTypes = {
  classNames: PropTypes.string,
  paths: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      label: PropTypes.string.isRequired,
    })
  ),
};
